<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form">
                <v-container style="max-width: 1200px; padding-top: 100px">
                    <v-layout row wrap>
                        <services-breadcrumbs></services-breadcrumbs>
                        <v-flex xs12 md10>
                            <h1>Восстановление КБМ</h1>
                        </v-flex>
                    </v-layout>
                    <kbm-free-recoveries v-if="!isAdmin"
                        :free-recoveries="freeRecoveries"
                        :policies-sold="policiesSold"
                    />
                </v-container>

                <v-container style="max-width: 1800px;">
                    <v-layout pt-4 pb-4 row wrap>
                        <v-flex xs12 sm6 md8>
                            <v-text-field
                                py-5
                                v-model="filters.search"
                                prepend-inner-icon="search"
                                label="Поиск в таблице по ФИО и номеру прав"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm3 md2 pt-4>
                            <v-btn
                                class="submit-button block"
                                @click="newSearch">Поиск
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm3 md2 pt-4>
                            <v-btn href="/kbm"
                                   target="_blank"
                                   class="submit-button block">Новый запрос
                            </v-btn>
                        </v-flex>
                    </v-layout>

                    <h3 class="py-0">Фильтры</h3>
                    <v-layout v-if="isAdmin" py-0 row wrap class="filters">
                        <v-flex xs12 sm6 py0>
                            <v-autocomplete
                                v-model="filters.curator"
                                :items="creatorsList"
                                label="Оформитель"
                                :search-input.sync="filters.creatorSearch"
                                item-value="id"
                                item-text="name"
                                multiple
                                chips
                                deletable-chips
                                :allow-overflow=false
                            >
                                <template v-slot:no-data>
                                    <v-list-tile>
                                        <v-list-tile-content>
                                            <v-list-tile-title>
                                                Не найдено: "<strong>{{ filters.curatorSearch }}</strong>".
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                    </v-layout>

                    <v-layout py-0 row wrap class="filters">
                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Создан, от"
                                v-model="filters.created_from"
                                :yearStarting="false"
                                :max="filters.created_to"
                                :isRequired="false"
                            />
                        </v-flex>
                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Создан, до"
                                v-model="filters.created_to"
                                :yearStarting="false"
                                :min="filters.created_from"
                                :isRequired="false"
                            />
                        </v-flex>

                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Дата запроса, от"
                                v-model="filters.request_from"
                                :yearStarting="false"
                                :max="filters.request_to"
                                :isRequired="false"
                            />
                        </v-flex>
                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Дата запроса, до"
                                v-model="filters.request_to"
                                :yearStarting="false"
                                :min="filters.request_from"
                                :isRequired="false"
                            />
                        </v-flex>

                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Дата ответа, от"
                                v-model="filters.response_from"
                                :yearStarting="false"
                                :max="filters.response_to"
                                :isRequired="false"
                            />
                        </v-flex>
                        <v-flex xs6 sm2 py0>
                            <osago-date
                                label="Дата ответа, до"
                                v-model="filters.response_to"
                                :yearStarting="false"
                                :min="filters.response_from"
                                :isRequired="false"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs9 sm10>
                            <a @click="cleanFilters" class="link">Очистить все</a>
                        </v-flex>
                    </v-layout>

                    <v-tabs
                        v-model="tab"
                        slider-color="#000"
                        show-arrows
                    >
                        <v-tab v-for="(tab, index) in tabsList" :key="index"
                               @click="(filters.tab = index) && (pagination.page = 1)"
                        >
                            {{ tab }}
                        </v-tab>
                    </v-tabs>
                </v-container>

                <v-container grid-list-lg style="max-width: 1800px" class="py-0">
                    <v-data-table
                        pt-4
                        :headers="tableHeaders"
                        :items="tableItems"
                        :total-items="total"
                        :loading="loading"
                        :pagination.sync="pagination"
                        :rows-per-page-items="[10,25,50]"
                        rows-per-page-text="Показывать по"
                        no-data-text="Нет данных"
                        no-results-text="Ничего не найдено"
                    >
                        <template v-slot:items="props">
                            <tr class="text-align-left" @click="rowClicked(props.item.id)">
                                <td v-if="isAdmin" class="text-align-left">{{ props.item.creator }}</td>
                                <td class="text-align-left">{{ props.item.status }}</td>
                                <td class="text-align-left">{{ props.item.name }}</td>
                                <td class="text-align-left">{{ props.item.created_at }}</td>
                                <td class="text-align-left">{{ props.item.prev_kbm }}</td>
                                <td class="text-align-left">{{ props.item.new_kbm }}</td>
                                <td class="text-align-left">{{ props.item.request_at }}</td>
                                <td class="text-align-left">{{ props.item.response_at }}</td>
                                <td class="text-xs-right px-0" @click.stop="">
                                    <v-menu>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                                <v-icon>more_vert</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-tile
                                                :href="'/kbm/' + props.item.id"
                                                target="_blank"
                                            >
                                                <v-list-tile-title>Просмотр</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                @click="removeItem(props.item.id)"
                                                v-if="props.item.can_delete"
                                            >
                                                <v-list-tile-title>Удалить</v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:pageText="props">
                            {{ props.pageStart }} - {{ props.pageStop }} из {{ props.itemsLength }}
                        </template>
                        <template v-slot:headers="props">
                            <tr>
                                <th
                                    v-for="header in props.headers"
                                    :key="header.text"
                                    :class="[
                                        'column text-xs-left',
                                        header.sortable ? 'sortable' : '',
                                        header.sortable ? (pagination.descending ? 'desc' : 'asc') : '',
                                        header.value === pagination.sortBy ? 'active' : '']"
                                    @click="header.sortable ? changeSort(header.value) : ''"
                                >
                                    {{ header.text }}
                                    <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                                </th>
                            </tr>
                        </template>
                    </v-data-table>
                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
import ServicesBreadcrumbs from "../services/ServicesBreadcrumbs";

export default {
    name: 'KbmRecoveryList',
    components: {"services-breadcrumbs": ServicesBreadcrumbs},
    props: {
        isAdmin: {
            default: false
        },
        creators: {
            default: []
        },
        freeRecoveries: {
            default: 0
        },
        policiesSold: {
            default: 0
        }
    },

    data: () => ({
        init: false,
        loading: false,
        filters: {
            tab: 0,
            search: '',
            creatorSearch: '',
            creator: [],
            created_from: null,
            created_to: null,
            request_from: null,
            request_to: null,
            response_from: null,
            response_to: null
        },
        pagination: {
            descending: true,
            sortBy: 'created_at',
            page: 1,
            rowsPerPage: 10,
            totalItems: 0
        },
        creatorsList: [],
        tabsList: ['Все', 'Запрошена история', 'Отказ', 'Выполненные'],
        tableHeaders: [
            {
                text: 'Статус',
                align: 'left',
                sortable: false,
                value: 'status'
            },
            {
                text: 'ФИО',
                align: 'left',
                sortable: true,
                value: 'fio'
            },
            {
                text: 'Дата создания',
                align: 'left',
                sortable: true,
                value: 'created_at'
            },
            {
                text: 'Предыдущий КБМ',
                align: 'left',
                sortable: false,
                value: 'kbm_old'
            },
            {
                text: 'Новый КБМ',
                align: 'left',
                sortable: false,
                value: 'kbm_new'
            },
            {
                text: 'Дата запроса',
                align: 'left',
                sortable: true,
                value: 'request_at'
            },
            {
                text: 'Дата ответа',
                align: 'left',
                sortable: true,
                value: 'response_at'
            },
            {
                text: '',
                align: 'left',
                sortable: false,
                value: 'actions'
            }
        ],
        tableItems: [],
        total: 0,
        tab: 0
    }),
    mounted() {
        if (this.isAdmin) {
            this.tableHeaders.unshift({
                    text: 'Оформитель',
                    align: 'left',
                    sortable: false,
                    value: 'creator'
            });

            function sortByName(objA, objB) {
                return objA.name < objB.name ? -1 : 1;
            }
            this.creatorsList = JSON.parse(window.atob(this.creators));
            this.creatorsList.sort(sortByName);
        }
        this.newSearch();
        this.init = true;
    },
    watch: {
        pagination: {
            handler() {
                if (!this.init) {
                    return;
                }
                this.newSearch();
            },
            deep: true
        }
    },

    methods: {
        getRecoveryList(data) {
            this.loading = true;
            axios.post('/kbm/list', data).then(response => {
                if (response && response.data.status === 'success') {
                    this.tableItems = JSON.parse(window.atob(response.data.list));
                    this.freeRecoveries = response.data.freeRecoveries;
                    this.policiesSold = response.data.policiesSold;
                    this.total = response.data.total;
                } else {
                    console.log(response);
                    PNotify.error('Не удалось получить список восстановлений КБМ.');
                }
            })
            .catch(error => {
                console.log(error);
                PNotify.error('Не удалось получить список восстановлений КБМ.');
            }).finally(() => { this.loading = false; });
        },

        rowClicked(id) {
            // window.open может быть подавлен политикой Firefox по запрету всплывающих окон,
            // поэтому конструируем новый элемент и кликаем по нему, а потом удаляем
            let link = document.createElement('a');
            link.id = 'my_link';
            link.style.cssText = 'display: none';
            link.href = '/kbm/' + id;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            link = undefined;
        },

        removeItem(id) {
            let that = this;
            PNotify.error({
                text: 'Удалить расчёт?',
                hide: false,
                stack: {
                    'dir1': 'down',
                    'modal': true,
                    'firstpos1': 25
                },
                modules: {
                    Confirm: {
                        confirm: true,
                        buttons: [
                            {
                                text: 'Удалить',
                                primary: false,
                                click: function () {
                                    axios.delete('/kbm/' + id + '/delete').then(response => {
                                        if (response.data && response.data.status === 'success') {
                                            Vue.delete(that.tableItems, that.tableItems.findIndex((v) => v.id === id));
                                            PNotify.removeAll();
                                            PNotify.success('Расчёт успешно удалён.');
                                        } else {
                                            console.log(response);
                                            PNotify.removeAll();
                                            PNotify.error('Не удалось удалить расчёт.');
                                        }
                                    }).catch(error => {
                                        console.log(error);
                                        PNotify.removeAll();
                                        PNotify.error('Не удалось удалить расчёт.');
                                    })
                                },
                            },
                            {
                                text: 'Отмена',
                                primary: false,
                                click: () => {
                                    PNotify.removeAll();
                                },
                            }
                        ]
                    },
                    Buttons: {
                        closer: false,
                        sticker: false
                    },
                    History: {
                        history: false
                    }
                }
            });
        },

        newSearch() {
            if (this.loading) {
                return;
            }
            const data = {
                s: this.pagination.sortBy,
                desc: this.pagination.descending,
                p: this.pagination.page,
                i: this.pagination.rowsPerPage,
                f: JSON.stringify(this.filters)
            };
            this.getRecoveryList(data);
        },

        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },

        cleanFilters() {
            this.filters.search = '';
            this.filters.creatorSearch = '';
            this.filters.creator = [];
            this.filters.created_from = null;
            this.filters.created_to = null;
            this.filters.request_from = null;
            this.filters.request_to = null;
            this.filters.response_from = null;
            this.filters.response_to = null;
            this.newSearch();
        }
    }
}
</script>

<style scoped>
/deep/ .v-tabs__item {
    justify-content: left;
    text-transform: none;
    font-size: 16px;
    font-weight: 500;
}

/deep/ .v-tabs__item--active {
    font-weight: 700;
}

/deep/ .text-align-center {
    text-align: center !important;
}

/deep/ table.v-table tbody td,
/deep/ table.v-table tbody th {
    height: 110px;
}

/deep/ table.v-table tbody td,
/deep/ table.v-table thead th {
    font-size: 14px;
}

/deep/ table.v-table thead td,
/deep/ table.v-table tbody td,
/deep/ table.v-table thead th,
/deep/ table.v-table tbody th {
    padding: 0 5px;
}

/deep/ table.v-table tbody td {
    cursor: pointer;
}

/deep/ table.v-table tbody td:not(:nth-child(1)),
/deep/ table.v-table tbody td:first-child {
    white-space: pre-line;
}

/deep/ h1 {
    font-size: 65px;
    font-family: 'SFPro';
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

@media(max-width: 600px) {
    /deep/ h1 {
        font-size: 40px;
    }
}

@media(max-width: 480px) {
    /deep/ h1 {
        font-size: 30px;
    }
}

/deep/ h2, h3 {
    font-family: 'SFProBold';
}

/deep/ h2 {
    font-size: 28px;
}

/deep/ h3 {
    font-size: 20px;
}

.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 56px;
    width: 100%;
    background-color: #00ba57 !important;
    text-align: center;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.submit-button >>> .v-btn__content {
    white-space: pre-wrap;
    margin: 16px 0 0;
    line-height: 1.1;
}

/deep/ .filters .v-input__slot,
/deep/ .filters .v-input__control,
/deep/ .filters .v-text-field {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}

.link {
    font-size: 14px;
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/kbm/KbmRecoveryList.vue